<template>
  <div class="body-wrapper-inner">
    <div class="container-fluid">
      <!--  Row 1 -->
      <div class="row">
        <div class="col-lg-8 d-flex align-items-strech">
          <div class="card w-100">
            <div class="card-body">
              <div class="d-sm-flex d-block align-items-center justify-content-between mb-9">
                <h5 class="card-title fw-semibold fs-6">Jumlah Responden</h5>
              </div>
              <!-- <div id="chart0"></div> -->
              <apexchart height="250" :options="chartOptions" :series="jumlahList.series"></apexchart>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="row">
            <div class="col-md-6 col-lg-12">
              <!-- Yearly Breakup -->
              <div class="card overflow-hidden">
                <div class="card-body">
                  <h5 class="card-title mb-9 fw-semibold">Jumlah Kasus Risiko Tinggi</h5>
                  <h4 class="fw-semibold mb-3 text-primary">
                    {{jml_kasus_risiko_tinggi.totalKasus}}
                    <small class="text-dark fw-normal">Kasus</small>
                  </h4>
                  <div class="d-flex align-items-center mb-3">
                    <template v-if="jml_kasus_risiko_tinggi.isIncrease">
                      <span
                        class="me-1 rounded-circle bg-light-success round-20 d-flex align-items-center justify-content-center"
                      >
                        <i class="ti ti-arrow-down-left text-success"></i>
                      </span>
                      <p
                        class="text-dark me-1 fs-3 mb-0"
                      >+{{jml_kasus_risiko_tinggi.persentasePerubahan}}%</p>
                    </template>
                    <template v-else>
                      <span
                        class="me-1 rounded-circle bg-light-success round-20 d-flex align-items-center justify-content-center"
                      >
                        <i class="ti ti-arrow-down-left text-success"></i>
                      </span>
                      <p
                        class="text-dark me-1 fs-3 mb-0"
                      >-{{jml_kasus_risiko_tinggi.persentasePerubahan}}%</p>
                    </template>

                    <p class="fs-3 mb-0">dari tahun kemarin</p>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="me-4">
                      <span class="round-8 bg-primary rounded-circle me-2 d-inline-block"></span>
                      <span class="fs-2">{{jml_kasus_risiko_tinggi.tahunSekarang}}</span>
                    </div>
                    <div>
                      <span class="round-8 bg-light-primary rounded-circle me-2 d-inline-block"></span>
                      <span class="fs-2">{{jml_kasus_risiko_tinggi.tahunSebelumnya}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-12">
              <!-- Monthly Earnings -->
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title mb-9 fw-semibold">Jumlah Pasien Rujukan</h5>
                  <h4 class="fw-semibold mb-3 text-secondary">
                    {{jml_pasien_rujukan.totalPasien}}
                    <small class="text-dark fw-normal">Pasien</small>
                  </h4>
                  <div class="d-flex align-items-center mb-3">
                    <template v-if="jml_pasien_rujukan.changeType == 'increase'">
                      <span
                        class="me-2 rounded-circle bg-light-danger round-20 d-flex align-items-center justify-content-center"
                      >
                        <i class="ti ti-arrow-up-right text-danger"></i>
                      </span>
                      <p class="text-dark me-1 fs-3 mb-0">+{{jml_pasien_rujukan.percentageChange}}%</p>
                    </template>
                    <template v-else>
                      <span
                        class="me-1 rounded-circle bg-light-success round-20 d-flex align-items-center justify-content-center"
                      >
                        <i class="ti ti-arrow-down-left text-success"></i>
                      </span>
                      <p class="text-dark me-1 fs-3 mb-0">-{{jml_pasien_rujukan.percentageChange}}%</p>
                    </template>

                    <p class="fs-3 mb-0">dari tahun kemarin</p>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="me-4">
                      <span class="round-8 bg-secondary rounded-circle me-2 d-inline-block"></span>
                      <span class="fs-2">{{jml_kasus_risiko_tinggi.tahunSekarang}}</span>
                    </div>
                    <div>
                      <span class="round-8 bg-light-primary rounded-circle me-2 d-inline-block"></span>
                      <span class="fs-2">{{jml_kasus_risiko_tinggi.tahunSebelumnya}}</span>
                    </div>
                  </div>
                </div>
                <div id="earning"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-5 col-xxl-4 d-flex align-items-stretch">
          <div class="card w-100">
            <div class="card-body">
              <div class="d-sm-flex d-block align-items-center justify-content-between mb-9">
                <h5 class="card-title fw-semibold">Distribusi Responden (Top 3)</h5>
              </div>
              <div class="table-responsive">
                <table class="table table-striped align-middle text-nowrap mb-0">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th class="w-75" scope="col">Kota/Kabupaten</th>
                      <th class="w-25 text-center" scope="col">Jumlah</th>
                    </tr>
                  </thead>
                  <tbody class="border-top">
                    <tr v-for="(req, idx) in topList" :key="req.id">
                      <td scope="row">{{ idx + 1 }}</td>
                      <td>
                        <div class="lh-1">{{req.city == 'undefined' || req.city == 'null' ? '-' : req.city}}</div>
                        <small class="text-dark">{{req.province == 'undefined' || req.province == 'null' ? '-' : req.province}}</small>
                      </td>
                      <td class="text-center">
                        <span class="badge text-bg-secondary fw-bold">{{req.jumlah}}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-7 col-xxl-8 d-flex align-items-stretch">
          <div class="card w-100">
            <div class="card-body">
              <div class="d-sm-flex d-block align-items-center justify-content-between mb-9">
                <h5 class="card-title fw-semibold">Tren Analisis</h5>
              </div>
              <!-- <div id="chart1"></div> -->
              <apexchart height="250" :options="chartOptions2" :series="trendList.series"></apexchart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import PieChart from '../PieChart'
import { mapGetters } from 'vuex'
// import Search from '../components/Search.vue'
// import Highlight from '../components/Highlight.vue'
// import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'

export default {
	components: {
		// PieChart,
		// Search,
		// Highlight,
		// EmptyPlaceholder,
	},
	data() {
		return {
			jml_kasus_risiko_tinggi: {},
			jml_pasien_rujukan: {},
			series: [
				{
					name: 'Sales',
					data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
				}
			],
			chartOptions: {
				chart: {
					type: 'area',
					height: 250,
					background: '#fbfbfb'
				},
				stroke: {
					curve: 'smooth'
				},
				xaxis: {
					categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep']
				}
			},
			chartOptions2: {
				chart: {
					type: 'bar',
					height: '250',
					background: '#fbfbfb',
					stacked: true
				},
				plotOptions: {
					bar: {
						horizontal: true
					}
				}
			},
			token: localStorage.getItem('token'),
			user_detail: JSON.parse(localStorage.getItem('user_detail')),
			user_login: JSON.parse(localStorage.getItem('user_login')),
			my_access: localStorage.getItem('my_access') ? JSON.parse(localStorage.getItem('my_access')) : []
		}
	},
	created() {
		if (!this.token) {
			this.$router.push('/login')
		}
		this.$store
			.dispatch('location/getDataPayload', {
				url: `dashboard/pasien_rujukan`
			})
			.then((res) => {
				this.jml_pasien_rujukan = res.payload
			})

		this.$store
			.dispatch('location/getDataPayload', {
				url: `dashboard/kasus_risiko_tinggi`
			})
			.then((res) => {
				console.log('--------------', res)
				this.jml_kasus_risiko_tinggi = res.payload
			})

		this.$store.dispatch('location/getDataThird', {
			url: `dashboard/trend_analisis`
		})
		this.$store.dispatch('location/getDataPayload2', {
			url: `dashboard/top_responden`
		})
		this.$store.dispatch('location/getDataPayload3', {
			url: `dashboard/jumlah_respondend`
		})

		// this.$store.dispatch('auth/getNotif')
		// this.$store.dispatch('dashboard/getMyRequest')
		// this.$store.dispatch('dashboard/getUserLog')
		// this.$store.commit('settings/setMenuActive', '/')
		// this.$store
		//   .dispatch("account/getAccess", {
		//     url: `profile/access`,
		//     params: {}
		//   })
		//   .then(() => {});
	},
	computed: {
		...mapGetters({
			trendList: 'location/getDataThird',
			topList: 'location/getDataPayload2',
			jumlahList: 'location/getDataPayload3'
			// myRequest: 'dashboard/getMyRequest',
			// UserDetail: 'auth/getUser_detail',
			// myAccess: 'auth/getMyAccess',
			// userLog: 'dashboard/getUserLog'
		})
	},
	methods: {
		onLogout: function() {
			this.$store
				.dispatch('auth/logout')
				.then((res) => {
					this.$router.push('/login')
				})
				.catch((err) => {})
		}
	}
}
</script>

<style>
.apexcharts-toolbar {
  z-index: 9 !important;
}
</style>
